import { render, staticRenderFns } from "./DataTableMethodTwo.vue?vue&type=template&id=3d89e132&scoped=true"
import script from "./DataTableMethodTwo.vue?vue&type=script&lang=js"
export * from "./DataTableMethodTwo.vue?vue&type=script&lang=js"
import style0 from "./DataTableMethodTwo.vue?vue&type=style&index=0&id=3d89e132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d89e132",
  null
  
)

export default component.exports